<template>
  <iframe
    width="100%"
    height="1000px"
    style="border: 0"
    :src="src"
  />
</template>

<script>
import * as $cache from '@/common/cache';

export default {
  data() {
    return {
      hostname: DOMAIN_API.perm.superset,
      token: $cache.localGet($cache.AUTH).token,
      path: encodeURIComponent('/superset/dashboard/92/?from_report=true'),
    };
  },

  computed: {
    src() {
      return `//${this.hostname}/login/?token=${this.token}&redirect=${this.path}&request_from=crm`;
    },
  },
};
</script>